import { useQuery } from 'react-query';
import { withHttp, queryClient } from '@/utils';
import { CommonDependency } from '@/dependency';
export type PreviewCard = {
  type: 'summary' | 'summary_large_image';
  title: string;
  url: string;
  host: string;
  icon: {
    thumbnail_url: string;
    url: string;
  };
  description: string;
  id: string;
};

export const clearUrlCardPreviewQuery = (url: string, key?: number) => {
  queryClient.setQueriesData(['/card/preview', url, key], () => null);
};
export const useUrlCardPreview = (url?: string, key?: number) => {
  const query = useQuery(
    ['/card/preview', url, key],
    async () => {
      return CommonDependency.api.postPreviewCard({ url: withHttp(url!) });
      // return request.post<{ card: PreviewCard }>('/card/add', { url: withHttp(url!) }).then(
      //   res => res?.card,
      //   () => null,
      // );
    },
    {
      enabled: !!url,
      cacheTime: 1000 * 60 * 5,
    },
  );
  return query;
};
